import { Box, Stack, Typography } from "@mui/material"
import { hasAmendsContent } from "authoring/routes/project/amends/lib/amends-content"
import { If } from "lib/@components/switch"
import { htmlToText } from "lib/html-to-text"
import { RejectionDecisionCounts } from "./rejection-decision-counts"

export function RejectionComment({ content, approvedCount = 0, rejectedCount = 0 }) {
    const hasContent = hasAmendsContent(content)
    const textContent = hasContent ? htmlToText(content, true).trim() : ""

    return (
        <Box
            sx={{
                bgcolor: "background.neutral",
                borderRadius: 2,
                p: 2,
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: hasContent ? 0.5 : 0 }}>
                <Typography variant="subtitle1" sx={{ flex: 1 }}>
                    Draft Rejected
                </Typography>
            </Stack>
            <If truthy={hasContent}>
                <Typography
                    data-cy="rejection-comment-content"
                    variant="body2"
                    sx={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                    }}
                >
                    {textContent}
                </Typography>
            </If>
            <RejectionDecisionCounts approvedCount={approvedCount} rejectedCount={rejectedCount} />
        </Box>
    )
}
